import Alert from 'client/components/aria/Alert/Alert';
import { useIntl } from 'react-intl';

const WorkpackAlertWarning = () => {
    const intl = useIntl();

    return (
        <Alert
            title={intl.formatMessage({ id: 'workpackAlertWarning.title' })}
            variant="secondary"
            className="govuk-!-margin-top-6"
        >
            <p className='govuk-!-font-weight-regular govuk-body-m govuk-!-margin-0'>{intl.formatMessage({ id: 'workpackAlertWarning.text' })}</p>
        </Alert>
    );
};

export default WorkpackAlertWarning;
